// Public UI adapted from Klargo-Reference/content/help/helpRegister.ts.
export const HELP_CHAPTERS = [
    {
        id: 'innan',
        titleKey: 'help.before.title',
        leadKey: 'help.before.lead',
        items: ['join', 'prepare', 'bankid', 'vehicles', 'price'],
    },
    {
        id: 'under',
        titleKey: 'help.during.title',
        leadKey: 'help.during.lead',
        items: ['changeBefore', 'change', 'swishCheck', 'swishFail', 'otherPayment', 'loan', 'cancel'],
    },
    {
        id: 'efter',
        titleKey: 'help.after.title',
        leadKey: 'help.after.lead',
        items: ['ownership', 'ownershipConfirm', 'insurance', 'documents', 'defect'],
    },
];
export const ALL_HELP_QUESTION_IDS = HELP_CHAPTERS.flatMap((chapter) => chapter.items);
export function helpQuestionKeys(id) {
    return { question: `help.q.${id}.question`, answer: `help.q.${id}.answer` };
}
export function chapterForQuestion(id) {
    return HELP_CHAPTERS.find((chapter) => chapter.items.includes(id))?.id;
}
export const HELP_QUESTION_ROUTES = {
    loan: [
        {
            to: '/sakerhet-och-bedragerier',
            labelKey: 'help.q.loan.link',
            audience: 'everyone',
        },
        {
            to: 'https://www.transportstyrelsen.se/sv/vagtrafik/fordon/skatter-och-avgifter/fordonsrelaterade-skulder/',
            labelKey: 'help.q.loan.externalLink',
            audience: 'everyone',
            external: true,
        },
    ],
    documents: [
        { to: '/affarshistorik', labelKey: 'help.route.history', audience: 'authenticated' },
    ],
    defect: [
        { to: '/affarshistorik', labelKey: 'help.route.history', audience: 'authenticated' },
    ],
};
export function helpRoutesFor(id, audience) {
    const routes = HELP_QUESTION_ROUTES[id] ?? [];
    return audience === 'authenticated'
        ? routes
        : routes.filter((route) => route.audience === 'everyone');
}
